import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function supportRouteI18n(): string {
  return (appRoutesI18nCache['help'] ??= $localize`:url-segment@@support-url-segment:support`);
}
